export function initCrosssellerTabs() {
    document.querySelectorAll('.itemcardCrossseller').forEach(container => {
        const tabs = Array.from(container.querySelectorAll('.itemcardCrosssellerTab'));
        const panels = Array.from(container.querySelectorAll('.itemcardCrosssellerList'));

        if (!tabs.length) return;

        let live = container.querySelector('.itemcardCrosssellerLive');
        if (!live) {
            live = document.createElement('div');
            live.className = 'itemcardCrosssellerLive sr-only';
            live.setAttribute('role', 'status');
            live.setAttribute('aria-live', 'polite');
            live.setAttribute('aria-atomic', 'true');
            container.appendChild(live);
        }

        container.setAttribute('role', 'tablist');
        tabs.forEach((tab, i) => {
            tab.setAttribute('role', 'tab');
            tab.setAttribute('aria-selected', 'false');
            tab.setAttribute('tabindex', '-1');
            const tag = tab.dataset.tag;
            tab.setAttribute('aria-controls', `panel-${tag}`);
            const panel = container.querySelector(`.itemcardCrosssellerList[data-tag="${tag}"]`);
            if (panel) {
                panel.setAttribute('role', 'tabpanel');
                panel.id = `panel-${tag}`;
                panel.setAttribute('aria-labelledby', tabs[i].id || `tab-${tag}`);
            }
        });

        function activateTab(tab) {
            const tag = tab.dataset.tag;
            tabs.forEach(t => {
                t.classList.remove('active');
                t.setAttribute('aria-selected', 'false');
                t.setAttribute('tabindex', '-1');
            });
            panels.forEach(p => p.style.display = 'none');

            tab.classList.add('active');
            tab.setAttribute('aria-selected', 'true');
            tab.setAttribute('tabindex', '0');
            // announce
            live.textContent = `${tab.textContent.trim()} selected.`;

            const panel = container.querySelector(`.itemcardCrosssellerList[data-tag="${tag}"]`);
            if (panel) panel.style.display = '';
        }

        activateTab(tabs[0]);

        tabs.forEach(tab => {
            tab.addEventListener('click', () => activateTab(tab));
        });
    });
}
